import './Footer.css';

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__top">
          <div className="footer__brand">
            <span className="footer__logo">◈ Ruxia Gold</span>
            <p className="footer__tagline">Wij kopen uw edelmetalen. Vertrouwde Waarde.</p>
          </div>
          <nav className="footer__nav">
            <a href="#home">Home</a>
            <a href="#prices">Aankoopprijzen</a>
            <a href="#products">Wat wij kopen</a>
            <a href="#about">Over ons</a>
            <a href="#contact">Contact</a>
          </nav>
        </div>
        <div className="footer__bottom">
          <p className="footer__legal">
            &copy; {year} Ruxia Gold. Alle prijzen zijn indicatief en geen financieel advies.
          </p>
        </div>
      </div>
    </footer>
  );
}
